import React from 'react';
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import av1 from "../1.png";
import av2 from "../2.png";
import av3 from "../3.png";
import av4 from "../4.png";


const Certificatecarousel = () => {
    return (
        <Carousel
        showArrows={true}
        infiniteLoop={true}
        showStatus={false}
        autoPlay={true}
        interval={3000}
        >
            <>
                <div className="my-carousel">
                    <img src={av1} alt="Oracel Certificate" />
                    <h3>Oracel Database Foundations</h3>
                </div>
            </>
            <>
                <div className="my-carousel">
                    <img src={av2} alt="TCS Certificate" />
                    <h3>TCS Certificate Of Internship</h3>
                </div>
            </>
            <>
                <div className="my-carousel">
                    <img src={av3} alt="HTML&CSS Certificate" />
                    <h3>HTML & CSS Certification</h3>
                </div>
            </>
            <>
                <div className="my-carousel">
                    <img src={av4} alt="JavaScript Certificate" />
                    <h3>JavaScript Certificate</h3>
                </div>
            </>
        </Carousel>
    )
}

export default Certificatecarousel
